/*
 * Booking Expert
 */
function factory({ window, document, thn }) {

  const engine = {};

  engine.languageCheck = function languageCheck(ctx) {

    return new Promise(function (resolve) {

      thn.domReady().then(function () {
        let lang = document.querySelector('.lang-mobile-code')?.textContent?.substr(0, 2);
        if (lang && ctx.langs.test(lang)) {
          resolve(lang);
          return;
        }

        lang = window.DOMAIN && window.DOMAIN.lang;
        if (lang && ctx.langs.test(lang)) {
          resolve(lang);
          return;
        }

        lang = ctx.getHtmlLang();
        if (lang && ctx.langs.test(lang)) {
          resolve(lang);
          return;
        }

        if ([1037061, 1038482].includes(thn.data.accountUserId)) {
          lang = window.location.pathname.match(ctx.urlRe);

          if (lang && ctx.langs.test(lang[1])) {
            resolve(lang[1]);

          }
        }
        resolve('it');
      });

    });
  };

  engine.priceObserveDom = function priceObserveDom(ctx) {
    // Observer for the newest version of Booking Expert
    if (window.location.pathname.match(/^\/(\w{2}(-\w{2})?\/?)?(search|book)\/?/)) {
      const container = document.querySelector('.search-results-wrapper > div[role="region"], .search-container');

      if (!container || thn.bookingExpertPriceUpdater) {
        return;
      }

      let canRefresh = false;
      thn.bookingExpertPriceUpdater = thn.debounce(function () {
        thn.pageCheck();
        const isLoading = !!document.querySelector('.loader');
        if (isLoading) {
          canRefresh = true;
        }

        if (canRefresh && !isLoading) {
          canRefresh = false;
          ctx.widget.update();
        }
      }, 500);

      thn.observeDom(container, thn.bookingExpertPriceUpdater, {
        childList: true,
        subtree: false,
        attributes: true,
      });

      thn.pageUnload(function () {
        delete thn.bookingExpertPriceUpdater;
      });
    }
  };

  engine._getRoomsDispo = function getRoomsDispo() {
    function splitByAdults(arr) {
      const result = [];
      let tempArray = [];

      arr.forEach((item) => {
        if (item.match(/Adults|Adulti|Adultes|Erwachsene|Взрослые/)) {
          if (tempArray.length > 0) {
            result.push(tempArray);
          }
          tempArray = [item];
        } else {
          tempArray.push(item);
        }
      });

      if (tempArray.length > 0) {
        result.push(tempArray);
      }
      return result;
    }

    let roomsInfoArray = [];
    const guestsInfo = (document.querySelector('.hotel-rates-guests, .search-compact-guests') || {}).textContent;

    if (guestsInfo) {
      const guestsTypes = guestsInfo.match(/\+/) ? guestsInfo.split(/\+/) : guestsInfo.split(/,/);
      const guests = guestsTypes && guestsTypes.map((el) => el.trim());
      let children = 0;

      if (guests && guests.length > 1) {
        if (guests.length >= 3) {
          if (/\((1?[0-7]|[0-9])-(1?[0-7]|[0-9])\)/.test(guests[0])) {
            children += parseInt(guests[2], 10);
          } else {
            const guestsByRoom = splitByAdults(guests);

            for (let i = 0; i < guestsByRoom.length; i += 1) {
              children = parseInt(guestsByRoom[i][1] ?? '0', 10) || 0;

              if (guestsByRoom[i].length === 3) {
                children += parseInt(guestsByRoom[i][2][0], 10);
              }

              const roomInfo = {
                adults: parseInt(guestsByRoom[i][0][0], 10),
                children: children,
              };
              roomsInfoArray.push(roomInfo);
            }
          }
        }
      } else {
        roomsInfoArray = [{
          adults: parseInt(guests[0], 10),
          children: children,
          childrenAges: [],
        }];
      }
      return roomsInfoArray;
    }
  };

  engine.generateSearchUrl = function generateSearchUrl(ctx) {
    const url = new URL(ctx.baseUrl);
    const validUrl = url.hostname.includes('.bookingexpert');
    // URL: https://be.bookingexpert.it/book/simple/step2?checkin=1727820000000&checkout=1727906400000&guesttypes[0][20829]=2&ages[0][20829]=18&ages[0][20829]=18&guesttypes[1][20829]=1&ages[1][20829]=18&guesttypes[1][20830]=1&ages[1][20830]=2&layout=15698&lang=en&currency=EUR
    if (!validUrl) {
      ctx.newUrl = '';
      return ctx;
    }

    url.searchParams.set('checkin', '[date_begin]');
    url.searchParams.set('checkout', '[date_end]');
    url.searchParams.set('currency', '[currency]');
    url.searchParams.set('lang', '[language]');

    // on the other side, format the relevant data...
    if (ctx.data.dateBegin && ctx.data.dateEnd) {
      ctx.newData.dateBegin = new Date(ctx.data.dateBegin.replace(/\//g, '-')).getTime();
      ctx.newData.dateEnd = new Date(ctx.data.dateEnd.replace(/\//g, '-')).getTime();
    }

    let roomsDispo = engine._getRoomsDispo();

    if (thn.empty(roomsDispo)) {
      roomsDispo = ctx.data.roomsDispo;
    }

    if (thn.empty(roomsDispo)) {
      roomsDispo = [{
        adults: 2,
        children: 0,
      }];
    }

    for (let i = 0; i < roomsDispo?.length; i += 1) {
      const room = roomsDispo[i];
      url.searchParams.set(`guesttypes[${i}][20829]`, room.adults);
      url.searchParams.set(`guesttypes[${i}][20830]`, room.children);
      url.searchParams.set(`guesttypes[${i}][20831]`, 0);
    }

    ctx.newUrl = url.toString();
    return ctx;

  };

  engine.priceParseData = function priceParseData(ctx) {

    const widgetData = {};

    if (window.searchtag) {
      widgetData.dateBegin = window.searchtag.criteria && thn.dateToString(window.searchtag.criteria.checkin, false);
      widgetData.dateEnd = window.searchtag.criteria && thn.dateToString(window.searchtag.criteria.checkout, false);

      const guestsRoomElement = document.querySelectorAll('.card-sale-label')[1]?.textContent?.trim() || '';
      const guestsRoomLines = guestsRoomElement.split('\n');
      const guestsRoom = guestsRoomLines[1]?.trim() || '';

      widgetData.adults = parseInt(guestsRoom.split('+')[0]?.trim() ?? '2', 10) || 2;
      widgetData.children = parseInt(guestsRoom.split('+')[1]?.trim() ?? '0', 10) || 0;

      if (guestsRoom.split('+').length > 2) {
        for (let i = 2; i < guestsRoom.split('+').length; i += 1) {
          widgetData.children += parseInt(guestsRoom.split('+')[i]?.trim() ?? '0', 10) || 0;
        }
      }

      widgetData.currency = (window.it && window.it.bookingexpert && window.it.bookingexpert.currency.code) || 'EUR';

      const priceElements = document.querySelectorAll('.hotel-rates-price > *:last-child .hotel-rates-price-content, .card-price .content-price');
      const prices = Array.from(priceElements).map((el) => thn.parseNumber(el.textContent.trim()));

      if (!prices.length) {
        widgetData.noRooms = true;
      } else {
        const perNight = document.querySelector('.hotel-rates-label') && !!document.querySelector('.hotel-rates-label').textContent.match(/pro Nacht|medio a notte|price per night|par nuit/);
        widgetData.price = perNight ? Math.min(...prices) : Math.round((Math.min(...prices) / thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd)) * 100) / 100;
        widgetData.set = true;
      }
    } else {
      // Newest Booking Expert Version

      widgetData.dateBegin = (thn.parseUrlParameter('checkin') || '').replace(/-/g, '/');
      widgetData.dateEnd = (thn.parseUrlParameter('checkout') || '').replace(/-/g, '/');

      widgetData.adults = thn.parseNumber(thn.parseUrlParameter('adults') || '2');
      widgetData.children = thn.parseNumber(thn.parseUrlParameter('children') || '0');
      widgetData.guests = widgetData.adults + widgetData.children;

      widgetData.rooms = 1;

      // We should check if there's any room that satisfies the number of guests, if not, we get the cheapest one
      // Obtain roomDetails
      const roomDetails = [...document.querySelectorAll('.room-rates__row.room-rates__rate')].map((el) => ({
        occupancy: thn.parseNumber((el.querySelector('.room-rates__occupancy strong') || '').textContent || '0'),
        price: document.querySelector('.room-rates__price.discounted') ? thn.parseNumber((el.querySelector('.room-rates__price.discounted span') || '').textContent) : thn.parseNumber((el.querySelector('.room-rates__price span') || '').textContent),
      }),
      );

      // Check if some room satisfies the number of guests
      const roomsThatSatisfiesGuests = roomDetails.filter((room) => widgetData.guests === room.occupancy);
      let price;

      if (roomsThatSatisfiesGuests.length) {
        price = Math.min(...roomsThatSatisfiesGuests.map((room) => room.price));
      } else {
        const otherRooms = roomDetails.filter((room) => widgetData.guests !== room.occupancy);

        price = Math.min(...otherRooms.map((room) => room.price));

        const occupancy = otherRooms.filter((room) => price === room.price);

        // if the number of guests is less than the occupopancy of the room we can't be sure that we're obtaining the best rate available
        if (occupancy[0] && (occupancy[0].occupancy > widgetData.guests)) {
          widgetData.priceSpecial = 1;
        }

        widgetData.adults = occupancy[0] ? occupancy[0].occupancy : 0;
        widgetData.children = 0;
        widgetData.guests = widgetData.adults;
      }

      if (price && widgetData.adults && widgetData.dateBegin && widgetData.dateEnd) {
        const nights = thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
        widgetData.price = price / nights;

        widgetData.currency = thn.parseUrlParameter('currency') || 'EUR';

        widgetData.set = true;
      } else {
        widgetData.noRooms = true;
      }
    }

    return widgetData;
  };

  engine.bookingParseData = function bookingParseData(ctx) {

    const widgetData = {};
    const reservation = window.reservation;

    if (reservation) {
      widgetData.bookingId = reservation.id;
      widgetData.dateBegin = reservation.checkin.replace(/-/g, '/');
      widgetData.dateEnd = reservation.checkout.replace(/-/g, '/');
      widgetData.currency = reservation.currency;
      widgetData.price = reservation.price;
    } else {
      // Newest Booking Expert Version
      const dateBeginRaw = ((document.querySelector('.list-column.details-table > ul > li:nth-child(5) .detail')).textContent || '').match(/\d{2}\s\w+\s\d{2,4}/);
      const dateEndRaw = ((document.querySelector('.list-column.details-table > ul > li:nth-child(6) .detail')).textContent || '').match(/\d{2}\s\w+\s\d{2,4}/);

      if (dateBeginRaw && dateEndRaw) {
        widgetData.bookingId = ((document.querySelector('.list-column.details-table > ul > li:nth-child(2) .detail') || []).textContent || '').trim();

        widgetData.dateBegin = thn.dateToString(dateBeginRaw[0]);
        widgetData.dateEnd = thn.dateToString(dateEndRaw[0]);

        const currencyRaw = ((document.querySelector('.grand-total .grand-total_price') || []).textContent || '').match(/[^\d\s\w.*]/);
        widgetData.currency = (currencyRaw.length ? currencyRaw[0] : thn.parseUrlParameter('currency')) || 'EUR';
        widgetData.price = thn.parseNumber(((document.querySelector('.grand-total .grand-total_price') || []).textContent || '').match(/\d+\.\d+/));
      }

    }

    return widgetData;
  };

  /**
   * @memberOf module:bs_90
   * @this thn.widgets.price
   * @see {@link Price#get_promocode}
   *
   * @param {object} ctx - The context object.
   */
  engine.getPromocode = function getPromocode(ctx) {
    const promocode = thn.parseUrlParameter('coupon');

    if (promocode) {
      ctx.promocode = promocode;
    }
    return ctx.promocode;
  };

  return engine;

}

export { factory };
